import colors from 'shared-tokens/utils/tokens/colors';
import createBreakpoint from 'shared-tokens/utils/breakpoints';
import createTransition from 'shared-tokens/utils/createTransition';

import { mainCls as galCls } from '../style';

const brTablet = createBreakpoint('s');
const brDesk = createBreakpoint('m');

export const mainCls = `${galCls}__slider__cta`;

export default {
  [mainCls]: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
  },
  [`${mainCls}__btn`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 136,
    fontSize: 15,
    lineHeight: '36px',
    [brTablet]: {
      fontSize: 14,
      lineHeight: '32px',
      '&.phoneCall': {
        display: 'none',
      },
      '&.specificLead': {
        transition: createTransition(['background']),
        background: `${colors.secondary.rgba} !important`,
        '& svg': {
          display: 'none',
        },
        '& span': {
          display: 'none',
        },
        '&:after': {
          content: '"Contatta"',
        },
        '&:hover': {
          background: `${colors.f0.rgba} !important`,
        }
      },
    },
  },
  [`${mainCls}__btn--phone`]: {
    marginRight: 3,
    width: 17,
    height: 17,
    [brDesk]: {
      width: 15,
      height: 15,
    },
  },  
  [`${mainCls}__btn--mail`]: {
    marginRight: 7,
    width: 19,
    height: 19,
    [brDesk]: {
      marginRight: 5,
      width: 17,
      height: 17,
    },
  },
  [`${mainCls}__sep`]: {
    marginTop: 16,
    marginBottom: 16,
    width: 120,
    height:1,
    backgroundSize: '4px 1px',
    backgroundImage: 'linear-gradient(90deg, #96a1b0 66%, rgba(255, 255, 255, 0) 0)',
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 0,
    [brDesk]: {
      marginTop: 12,
      marginBottom: 12,
      width: 90,
    },
  },

  [`${mainCls}__pdpbtn`]: {
    padding: '8px 0 7px 0',
    width: 158,
    textAlign: 'center',
    border: 'solid 1px #96a1b0',
    transition: createTransition(['color', 'border-color']),
    '&:hover': {
      color: `${colors.f0.rgba} !important`,
      borderColor: '#505A65',
    },
    [brDesk]: {
      padding: '6px 0 5px 0',
      width: 134,
      fontSize: '13px',
      borderColor: '#d8dbdf',
    },
  },
  [`${mainCls}__back`]: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    bottom: 36,
    right: 16,
    '& svg': {
      marginLeft: 8,
    },
    [brDesk]: {
      fontSize: 12,
      '& svg': {
        marginLeft: 4,
        width: 14,
      },
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  [`${mainCls}__back--txt`]:{
    paddingTop: 2,
    [brDesk]: {
      paddingTop: 0,
    },
  },

  [`${mainCls}__img`]: {
    opacity: .15,
  },
};
